/**
 * Determines if AI Studio button should be shown based on the abWeaverAiStudio experiment
 * Variant 1 (50%) shows the button, variant 0 (50%) is control
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if AI Studio button should be shown, false if it should be hidden
 */
export function shouldShowAiStudio(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}
